import { heroHighlights, liveFeed } from "@/mocks/home";

export default function HeroSection() {
  const tickerItems = liveFeed.slice(0, 6);

  return (
    <section id="top" className="relative w-full pt-24 md:pt-32 pb-0">
      <div className="absolute inset-0 paper-grid opacity-60 pointer-events-none" />
      <div className="relative w-full px-4 md:px-10">
        <div className="flex items-center gap-3 md:gap-5 mb-6 md:mb-10">
          <span className="text-xs md:text-sm tracking-[0.35em] text-foreground-500 uppercase">
            Today Dispatch
          </span>
          <span className="flex-1 h-px bg-foreground-950/12" />
          <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
            今日更新 · 第 001 期
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-8 reveal">
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black leading-[1.08] tracking-tight text-foreground-950">
              今日新料，
              <br />
              比热点更快一步。
            </h2>
            <p className="mt-6 md:mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-foreground-700">
              爱黑料网今日更新速递，全网黑料实时同步。抢先获取今日新料与最快黑料汇总，
              热门爆料一眼看全，实时追新料不再靠一条条翻。
            </p>

            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4">
              <a
                href="#today"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-fill text-lg" />
                看今日新料
              </a>
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md border hairline text-foreground-800 text-base font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg" />
                追新热榜
              </a>
            </div>

            <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {heroHighlights.map((item) => (
                <div key={item.index} className="border-t-2 border-foreground-950/85 pt-4">
                  <span className="font-heading text-sm text-primary-600">{item.index}</span>
                  <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4 reveal">
            <figure className="relative">
              <div className="w-full aspect-[9/11] overflow-hidden rounded-lg border hairline bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20portrait%20silhouette%20with%20warm%20crimson%20and%20cream%20paper%20texture%2C%20soft%20studio%20lighting%2C%20minimal%20grain%2C%20fashion%20editorial%20aesthetic%2C%20muted%20warm%20background%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=1150&seq=ahl-cover-01&orientation=portrait"
                  alt="爱黑料网今日更新杂志封面视觉"
                  title="爱黑料网今日更新 · 杂志封面视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              <figcaption className="absolute bottom-4 left-4 right-4 rounded-md bg-background-50/92 backdrop-blur px-4 py-3 border hairline">
                <p className="text-xs text-foreground-500">今日更新</p>
                <p className="mt-1 font-heading text-sm font-bold text-foreground-950">
                  零点以来累计 1,286 条新料
                </p>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>

      <div className="relative mt-12 md:mt-16 w-full border-y hairline bg-background-100/70 overflow-hidden">
        <div className="flex items-center">
          <div className="hidden md:flex items-center gap-2 px-6 md:px-10 py-4 bg-primary-500 text-background-50 shrink-0 h-full">
            <span className="w-2 h-2 rounded-full bg-background-50 animate-pulse-soft" />
            <span className="text-sm font-medium whitespace-nowrap">实时快讯</span>
          </div>
          <div className="flex-1 overflow-hidden py-4">
            <div className="flex w-max animate-marquee gap-10 md:gap-14">
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span
                  key={`${item.title}-${i}`}
                  className="flex items-center gap-3 text-sm text-foreground-700 whitespace-nowrap"
                >
                  <span className="text-primary-600 font-medium">{item.time}</span>
                  {item.title}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}